/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_DomainInputs */

const en_admin_settings_fields_r2_domain = /** @type {(inputs: Admin_Settings_Fields_R2_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const zh_admin_settings_fields_r2_domain = /** @type {(inputs: Admin_Settings_Fields_R2_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公共域名`)
};

/**
* | output |
* | --- |
* | "Domain" |
*
* @param {Admin_Settings_Fields_R2_DomainInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_domain = /** @type {((inputs?: Admin_Settings_Fields_R2_DomainInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_DomainInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_domain(inputs)
	return zh_admin_settings_fields_r2_domain(inputs)
});
export { admin_settings_fields_r2_domain as "admin.settings.fields.r2_domain" }